import React from 'react'
import classnames from "classnames";
import { Modal, Form } from "react-bootstrap";

//import action
import { addSpotPair } from '../../actions/tradePairAction'

//import lib
import { toastAlert } from '../../lib/toastAlert';
import isEmpty from '../../lib/isEmpty'
import { SocialMediaEdit } from '../../actions/cmsActions';


const options = [{ 'value': "binance", 'label': "binance" }, { 'value': "off", 'label': "Off" }];


const initialFormValue = {
    "_id" : "",
    "Heading" : "",
    "SubHeading" : "",
    "Description" : "",
    "Youtube" : "",
    "FaceBook" : "",
    "Telegram" : "",
    "Instagram" : "",
    "Reddit" : "",
    "Twitter" : ""
}

class EditpaymenttypeModal extends React.Component {
    constructor() {
        super();
        this.state = {
            formValue: initialFormValue,
            errors: {},
            loader: false
        };
    }

    handleChange = e => {
        e.preventDefault();
        let { name, id, value } = e.target;
        let formData = { ...this.state.formValue, ...{ [id]: value } };
        this.setState({ formValue: formData });
        if (!isEmpty(value)) {
            this.setState({ errors: {} })
        }
    };

    handleClose = () => {
        const { onHide } = this.props;
        onHide();
        this.setState({ 'formValue': initialFormValue, errors: {} });

    }

    handleSubmit = async e => {
        e.preventDefault();
        try {
            const { formValue } = this.state;
            const { fetchData } = this.props;
            
            let reqData = formValue;
            this.setState({ 'loader': true })
            // let { status, loading, result, error, message,pairName } = await Addoffertaghook(reqData);
            var result = await SocialMediaEdit(reqData);
            // this.setState({ 'loader': true })
            if (result?.data?.type === 'success') {
                fetchData();
                toastAlert('success', result?.data?.message, 'addTemplate');
                this.handleClose()
            } else {
                // if(error.pairName == 'Currency pair is not exists in binance'){
                //     toastAlert('error', error.pairName); 
                //     // this.handleClose() 
                // }
                if (result?.data?.error) {
                    this.setState({ errors: result?.data?.error })
                    this.setState({ 'loader': false })
                }
                toastAlert('error', result?.data?.message, 'addSpotPair');
            }
            this.setState({ 'loader': false })
        }
        catch (err) { }
    }

    // componentDidMount(){
    //     console.log("domponent did mount" , this.props);
    //     var data = this.state.formValue;
    //     data.name = this.props?.record?.name;
    //     data.description = this.props?.record?.description;
    //     data.status = this.props?.record?.status
    // }
    componentWillReceiveProps(nextProps){
        var data = this.state.formValue;
        data.Heading = nextProps?.record?.Heading;
        data.SubHeading = nextProps?.record?.SubHeading;
        data.Description = nextProps?.record?.Description;
        data.Youtube = nextProps?.record?.Youtube;
        data.FaceBook = nextProps?.record?.FaceBook;
        data.Telegram = nextProps?.record?.Telegram;
        data.Instagram = nextProps?.record?.Instagram;
        data.Reddit = nextProps?.record?.Reddit;
        data.Twitter = nextProps?.record?.Twitter;
        data._id = nextProps?.record?._id;
        this.setState({formValue : data});
    }



    render() {
        const { errors, loader } = this.state;
        const { Heading, SubHeading, Description, Youtube, FaceBook, Telegram, Instagram, Reddit, Twitter, status , name , description, _id } = this.state.formValue

        const { isShow, currencyOptions } = this.props;


        return (
            <div>
                <Modal
                    show={isShow}
                    onHide={this.handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    size="lg"
                    centered
                    scrollable={true}
                >
                    <Modal.Header closeButton>
                        <h4 className="modal-title">Edit Social Media</h4>
                    </Modal.Header>
                    <Modal.Body>

                        <form noValidate id="add-spot">

                            {/* <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="identifier">Base Currency </label>
                                </div>
                                <div className="col-md-9">
                                    <Form.Control
                                        as="select"
                                        custom
                                        name={'firstCurrencyId'}
                                        id={'firstCurrencyId'}
                                        value={firstCurrencyId}
                                        onChange={this.handleChange}
                                    >
                                        <option value={''}>{"Select Base Currency"}</option>
                                        {
                                            currencyOptions && currencyOptions.length > 0 && currencyOptions.map((item, key) => {
                                                return (
                                                    <option key={key} value={item.value}>{item.label}</option>
                                                )
                                            })
                                        }
                                    </Form.Control>
                                    <span className="text-danger">{errors.firstCurrencyId}</span>
                                </div>
                            </div> */}
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">Heading</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={Heading}
                                        name="Heading"
                                        id="Heading"
                                        type="text"
                                        className={classnames("form-control", {
                                            invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">SubHeading</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={SubHeading}
                                        name="SubHeading"
                                        id="SubHeading"
                                        type="text"
                                        className={classnames("form-control", {
                                           // invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">Description</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={Description}
                                        name="Description"
                                        id="Description"
                                        type="text"
                                        className={classnames("form-control", {
                                         //   invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">Youtube</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={Youtube}
                                        name="Youtube"
                                        id="Youtube"
                                        type="text"
                                        className={classnames("form-control", {
                                           // invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">FaceBook</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={FaceBook}
                                        name="FaceBook"
                                        id="FaceBook"
                                        type="text"
                                        className={classnames("form-control", {
                                           // invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">Telegram</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={Telegram}
                                        name="Telegram"
                                        id="Telegram"
                                        type="text"
                                        className={classnames("form-control", {
                                          //  invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">Instagram</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={Instagram}
                                        name="Instagram"
                                        id="Instagram"
                                        type="text"
                                        className={classnames("form-control", {
                                            invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">Reddit</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={Reddit}
                                        name="Reddit"
                                        id="Reddit"
                                        type="text"
                                        className={classnames("form-control", {
                                           // invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label htmlFor="taker_fees">Twitter</label>
                                </div>
                                <div className="col-md-9">
                                    <input
                                        onChange={this.handleChange}
                                        value={Twitter}
                                        name="Twitter"
                                        id="Twitter"
                                        type="text"
                                        className={classnames("form-control", {
                                         //   invalid: errors.name
                                        })}
                                    />
                                    {/* <span className="text-danger">{errors.name}</span> */}
                                </div>
                            </div>

                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={this.handleClose}
                            disabled={loader}
                        >
                            Close
                        </button>
                        <button
                            onClick={this.handleSubmit}
                            className="btn btn-primary"
                            disabled={loader}
                        >
                            {loader && <i class="fas fa-spinner fa-spin"></i>}
                            Submit
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}



export default EditpaymenttypeModal;
